import { render, staticRenderFns } from "./ProfilesList.vue?vue&type=template&id=6bf8ef6c&scoped=true"
import script from "./ProfilesList.vue?vue&type=script&lang=js"
export * from "./ProfilesList.vue?vue&type=script&lang=js"
import style0 from "./ProfilesList.vue?vue&type=style&index=0&id=6bf8ef6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8ef6c",
  null
  
)

export default component.exports